import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import registerServiceWorker from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(<CookiesProvider><App key="app-screen"/></CookiesProvider>, document.getElementById('rootPage'));
registerServiceWorker();